
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class QuestionReplyDtoModel extends Model<QuestionReplyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'questionReplyDto.property.companyId' },
		{ name: 'orderId', type: 'guid', languageString: 'questionReplyDto.property.orderId' },
		{ name: 'orderIds', type: 'string[]', languageString: 'questionReplyDto.property.orderIds', isArray: true },
		{ name: 'orderLineId', type: 'guid', languageString: 'questionReplyDto.property.orderLineId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'questionReplyDto.property.taskflowId' },
		{ name: 'replyData', type: 'string', languageString: 'questionReplyDto.property.replyData' },
		{ name: 'questionnaireId', type: 'guid', languageString: 'questionReplyDto.property.questionnaireId' },
		{ name: 'questionTag', type: 'string', languageString: 'questionReplyDto.property.questionTag' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public orderId?: string;
	public orderIds: string[];
	public orderLineId?: string;
	public taskflowId?: string;
	public replyData: string;
	public questionnaireId?: string;
	public questionTag: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderIds = [];
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.replyData = '';
		this.questionnaireId = undefined;
		this.questionTag = '';
		
	}
	getProperties(){
		return QuestionReplyDtoModel.classProperties;
	}
}

